import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';

import './styles/css/app.css';
import './styles/css/mobile.css';

import React from 'react';
import CustomerKnowlegePage from './routes/CustomerKnowledgeBase';

const LandingPage = function landingPage() {
  return (
    <div className="mt-5">
      <CustomerKnowlegePage />
    </div>
  );
};
export default LandingPage;
